import { render, staticRenderFns } from "./selectAuthorizeAccount.vue?vue&type=template&id=2e54165a&scoped=true&"
import script from "./selectAuthorizeAccount.vue?vue&type=script&lang=js&"
export * from "./selectAuthorizeAccount.vue?vue&type=script&lang=js&"
import style0 from "./selectAuthorizeAccount.vue?vue&type=style&index=0&id=2e54165a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54165a",
  null
  
)

export default component.exports